<template>
  <div class="wrapper">
    <div class="noteComposer">
      <div class="textAreaWrapper">
        <textarea
          name=""
          id=""
          placeholder="Type to add note"
          v-model="newNoteText"
          @keyup.enter="_onEnter"
        />
      </div>
      <div class="composerAction">
        <button :disabled="!newNoteText.length" @click="_addNote">
          Add Note
        </button>
      </div>
    </div>
    <patient-note
      v-for="(note, index) in notes"
      :key="note.patientNoteID"
      :note="note"
      @delete-note="_deleteNote"
      :index="index"
    />
  </div>
</template>

<script>
  /* eslint-disable */
import moment from "moment";
import { ApiCalls } from "../../../api-calls";
import PatientNote from "../patient-note/patient-note.vue";

export default {
  components: { PatientNote },
  name: "ManagePatientNotes",
  data: () => ({
    notes: [],
    newNoteText: "",
  }),
  props: {
    patientId: {
      type: Number,
      default: -1,
    },
  },
  created() {
    this._loadNotes();
  },
  methods: {
    async _loadNotes() {
      try {
        const { data } = await ApiCalls.fetchPatientNotes(this.patientId);
        const formattedNotes = this._formatNotes(data);
        this.notes = formattedNotes;
      } catch (error) {
        console.log("error", error);
        this.notes = [];
      }
    },
    _preparePayload() {
      return {
        PatientID: this.patientId,
        Note: this.newNoteText,
      };
    },
    async _addNote() {
      if (this.newNoteText.length) {
        const newIndex = this.notes.length;
        try {
          const payload = this._preparePayload();
          this.notes.push({
            patientID: this.patientID,
            note: this.newNoteText,
            creationDate: moment().format("MM/DD/YYYY"),
          });
          await ApiCalls.addPatientNote(payload);
          this._loadNotes();
        } catch (error) {
          this.notes.splice(newIndex, 1);
        }
        this.newNoteText = "";
      }
    },
    async _deleteNote({ noteIndex, note }) {
      console.log("noteIndex, note", noteIndex, note);
      try {
        ApiCalls.deletePatientNote(note.patientNoteID);
        this.notes.splice(noteIndex, 1);
      } catch (error) {
        console.log('error', error)
        // a
      }
    },
    _formatNotes(notes) {
      return notes.map((note) => ({
        ...note,
        creationDate: moment(note.creationDate).format("MM/DD/YYYY"),
      }));
    },
    _onEnter (event) {
      if (event.key === "Enter") {
        if (event.ctrlKey === true || event.shiftKey === true) {
            this._addNote();
         }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .note {
    background-color: #ffffff2a;
    padding: 1rem 2rem;
    border-radius: 8px;
    border: 1px solid #00b65b;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.123);
    color: rgb(48, 48, 48);
    display: flex;
    margin-bottom: 1rem;
    align-items: flex-start;
    .createdOn {
      flex: 2;
      font-weight: 600;
    }
    .noteText {
      flex: 15;
    }
    .noteAction {
      height: 100%;
      display: flex;
      justify-content: flex-end;
      // align-items: flex-end;
      flex: 1;
      // background-color: #00b65b;
      text-align: center;
      padding-left: 2rem;
      position: relative;
      .confirmPopup {
        background-color: rgb(241, 241, 241);
        border-color: 2px solid red;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.212);
        width: 150px;
        cursor: pointer;
        height: 80px;
        color: rgb(29, 28, 28);
        position: absolute;

        .option {
          padding-bottom: 8px;
          font-size: 0.8rem;
        }

        .confirm {
          padding-top: 8px;
          color: red;
          font-weight: 600;
          font-size: 1rem;
        }

        top: 0px;
        right: -15px;
      }
    }
  }
  .noteComposer {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1.5rem;
    // background: #00b65b;
    .textAreaWrapper {
      flex: 13;
      textarea {
        width: 100%;
        min-height: 100px;
        background-color: #f0f0f0;
        outline: none;
        padding: 10px 20px;
      }
    }
    .composerAction {
      flex: 2;
      display: flex;
      justify-content: center;
      align-items: center;
      button {
        padding: 15px 20px;
        background-color: #00b65b;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.123);
        border-radius: 12px;
        color: white;
        font-weight: 600;
        &:hover {
          background-color: #008844;
        }
        &:disabled {
          opacity: 0.3;
          cursor: not-allowed;
        }
      }
    }
  }
}
</style>
